import { type AxiosResponse } from 'axios';
import { setSubmitFailed, setSubmitSucceeded, startSubmit, stopSubmit } from 'redux-form';
import { call, put, takeLatest } from 'redux-saga/effects';

import { ActionKeys } from '~/actions/constants';
import * as packagesActions from '~/actions/packages.actions';
import { DEFAULT_PACKAGE_UNITS_FORM } from '~/pages/Settings/Packages/DefaultPackageUnitsForm';
import * as packagesService from '~/services/packages.service';
import { Events, track } from '~/utils/segment';

function* fetchDefaultPackageUnits() {
  try {
    const response: AxiosResponse<{ dimension_unit: string; weight_unit: string }> = yield call(
      packagesService.get,
    );
    const payload: packagesActions.DefaultPackageUnitsPayload = {
      defaultDistanceUnit: response.data.dimension_unit,
      defaultWeightUnit: response.data.weight_unit,
    };
    yield put(packagesActions.fetchDefaultPackageUnitsSuccess(payload));
  } catch (err) {
    yield put(packagesActions.fetchDefaultPackageUnitsError(err.message));
  }
}

function* updateDefaultPackageUnits(
  action: ReturnType<typeof packagesActions.updateDefaultPackageUnits>,
) {
  try {
    const servicePayload = {
      dimension_unit: action.payload.defaultDistanceUnit,
      weight_unit: action.payload.defaultWeightUnit,
    };
    yield put(startSubmit(DEFAULT_PACKAGE_UNITS_FORM));
    yield call(packagesService.put, servicePayload);
    yield put(packagesActions.updateDefaultPackageUnitsSuccess(action.payload));
    yield call(track, Events.save_default_package_units);
    yield put(stopSubmit(DEFAULT_PACKAGE_UNITS_FORM));
    yield put(setSubmitSucceeded(DEFAULT_PACKAGE_UNITS_FORM));
  } catch (err) {
    yield put(packagesActions.fetchDefaultPackageUnitsError(err.message));
    yield put(stopSubmit(DEFAULT_PACKAGE_UNITS_FORM));
    yield put(setSubmitFailed(DEFAULT_PACKAGE_UNITS_FORM));
  }
}

export default [
  takeLatest(ActionKeys.FETCH_PACKAGE_DEFAULT_UNITS, fetchDefaultPackageUnits),
  takeLatest(ActionKeys.UPDATE_PACKAGE_DEFAULT_UNITS, updateDefaultPackageUnits),
];
